package com.sweetlime.bingeamigo.presentation.features.search

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.model.Movie
import com.sweetlime.bingeamigo.repository.ReviewRepository
import com.sweetlime.bingeamigo.repository.TmdbRepository
import com.sweetlime.bingeamigo.state.MovieState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class SearchViewModel(
    private val repository: TmdbRepository,
    private val reviewRepository: ReviewRepository,
): ViewModel() {
    private val _movies = MutableStateFlow<MovieState>(MovieState.Idle)
    val movies: StateFlow<MovieState> get() = _movies.asStateFlow()

    private val _query = MutableStateFlow("")
    val query: StateFlow<String> get() = _query.asStateFlow()

    private val _communityRatings = MutableStateFlow<Map<Int, Double>>(emptyMap())
    val communityRatings: StateFlow<Map<Int, Double>> = _communityRatings.asStateFlow()

    init {
        loadPopularMovies()
    }

    fun onQueryChange(query: String) { _query.value = query }

    fun searchMovies(query: String) {
        _movies.value = MovieState.Loading
        viewModelScope.launch {
            try {
                val movies = repository.searchMovies(query)
                _movies.value = MovieState.Success(movies)
                fetchCommunityRatings(movies)
            } catch (e: Exception) {
                _movies.value = MovieState.Error(e.message ?: "Unknown error")
                println(e.message)
            }
        }
    }

    fun loadPopularMovies() {
        if (_movies.value is MovieState.Success) return
        _movies.value = MovieState.Loading
        viewModelScope.launch {
            try {
                val movies = repository.getPopularMovies()
                _movies.value = MovieState.Success(movies)
                fetchCommunityRatings(movies)
            } catch (e: Exception) {
                _movies.value = MovieState.Error(e.message ?: "Unknown error")
            }
        }
    }

    private suspend fun fetchCommunityRatings(movies: List<Movie>) {
        val docIds = movies.map { "MOVIE_${it.id}" }
        val summaries = reviewRepository.getContentSummaries(docIds)
        _communityRatings.value = summaries.mapNotNull { (key, summary) ->
            if (summary.avgRating > 0.0) key.removePrefix("MOVIE_").toIntOrNull()?.let { id -> id to summary.avgRating } else null
        }.toMap()
    }
}
